import React, { ReactNode } from "react";
import "./BottomSheetFooter.scss";

function BottomSheetFooter({ children }: { children: ReactNode }) {
  return <div className="BottomSheetFooter">{children}</div>;
}

export default React.memo(BottomSheetFooter);
